<template>
  <div
    class="window-tab-item inline-flex items-center cursor-pointer select-none rounded-t p-1.5 relative border-l border-t last:border-r shadow"
    :data-active="active || null"
    :class="{
     'text-sm text-white bg-primary border-primary p-1': active,
      'text-xs hover:text-primary': !active
    }"
		style="transition: all 0.2s;will-change: font-size, color;"
	>
    <span
			:id="id"
      class="window-tab truncate font-medium tracking-tighter"
      :class="[
				pinned ? 'italic' : '',
				$attrs.class
			]"
			v-tooltip="{
				content: title,
				disabled: !isTruncated
			}"
    >
      {{ title }}
    </span>
		<AppIcon
			icon="fa-regular fa-close"
			class="window-tab-close cursor-pointer p-1 ml-auto rounded shrink-0"
			:class="{
        'hover:bg-black/10': active,
        'hover:bg-gray-100 hover:text-primary': !active
      }"
			@click.stop="$emit('close')"
		/>
	</div>
</template>

<script setup lang="ts">
const props = defineProps<{
	title: string;
	pinned?: boolean;
	active?: boolean;
}>();

const id = Math.random().toString(36);
const isTruncated = ref<boolean>(false);

let resizeObserver: ResizeObserver | null = null;

onMounted(() => {
	const element = document.getElementById(id);
	if (!element) return;

	const updateTruncated = () => {
		isTruncated.value = element.scrollWidth > element.clientWidth;
	};
	updateTruncated();
	resizeObserver = new ResizeObserver(updateTruncated);
	resizeObserver.observe(element);
});

onBeforeUnmount(() => resizeObserver?.disconnect());

const { title, pinned, active } = toRefs(props);
defineEmits<{
	(e: "close"): void;
}>();
</script>

<style scoped></style>
